import React from "react";
import PropTypes from "prop-types";

export const CompaniesSidebarIcon = (props) => {
  return (
    <>
      <svg
     width="24"
     height="24"
     viewBox="0 0 24 24"
     fill="none"
     xmlns="http:www.w3.org/2000/svg"
     {...props}
   >
     <path
       d="M10 12H14M10 8H14M14 21V18C14 16.8962 13.1038 16 12 16C10.8962 16 10 16.8962 10 18V21M6 10H4C2.89543 10 2 10.8954 2 12V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V9C22 7.89543 21.1046 7 20 7H18M6 21V5C6 3.89543 6.89543 3 8 3H16C17.1046 3 18 3.89543 18 5V21"
       stroke={props.selectedIcon ? "#448BCA" : "#6B778C"}
       strokeWidth="1.66667"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
   </svg>
    </>
  )

};

CompaniesSidebarIcon.propTypes = {
  selectedIcon: PropTypes.bool,
};

